window.customElements.define(
  'custom-bundle-contents-accordion',
  class CustomBundleContentsAccordion extends window.HTMLElement {
    connectedCallback() {
      this.initEventListeners();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    initEventListeners() {
      this.toggles = this.querySelectorAll('.custom-bundle-contents-accordion__toggle');
      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', this.handleToggleClick.bind(this));
      });
    }

    removeEventListeners() {
      this.toggles.forEach((toggle) => {
        toggle.removeEventListener('click', this.handleToggleClick.bind(this));
      });
    }

    handleToggleClick(event) {
      const toggle = event.currentTarget;
      const cardId = toggle.getAttribute('data-card-id');
      const expander = this.querySelector(`[data-expander="${cardId}"]`);

      if (toggle && expander) {
        expander.classList.toggle('expanded');
        toggle.classList.toggle('expanded');
      }
    }
  }
);
